<template>
  <div class="">



    <div class="d-flex justify-center mt-5 mb-2">
      <v-sheet class="">

        <div class="d-flex justify-start" style="height: 40px;">
          <img class="ma-1 pa-0" height="30px" :src="icon">
          <p class="ml-1 pa-0" style="font-size: 26px; font-weight:400;">
            {{ name }}
          </p>
        </div>

        <div style="width: 600px;" class="pr-3">
          <v-carousel :show-arrows="false" touchless continuous cycle class="p0 m0 my-0 py-0" height="400">
            <v-carousel-item v-for="(img, index) in images" v-bind:key="games" :src="img" width="600px" cover>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-sheet>

      <v-sheet class="" width="320px">
        <div class="" style="height: 40px;"></div>
        <img class="game_header_image_full" :src="capsule" width="320px">
        <v-sheet class="" width="310px">
          <div class="">
            <p class="text" style="height: 150px;">Try and survive in the world of Nomad. Build a base and protect it from
              raiding players.
              Scavenge food, weapons and medical supplies across the island. Team up with others and make a base. Make
              your
              mark on the world of Nomad.</p>
            <p class="text" style="height: 25px;">RELEASE DATE: 26 Jun, 2015</p>
            <div class="d-flex justify-start">
              <v-chip x-small class="mr-1 pt-3 pb-3" label color="orange">FPS</v-chip>
              <v-chip x-small class="ml-1 mr-1 pt-3 pb-3" label color="orange">Free To Play</v-chip>
              <v-chip x-small class="ml-1 mr-1 pt-3 pb-3" label color="orange">Survival</v-chip>
              <v-chip x-small class="ml-1 mr-1 pt-3 pb-3" label color="orange">Zombies</v-chip>
            </div>
          </div>
        </v-sheet>
      </v-sheet>
    </div>


    <div class="d-flex justify-center mb-2">
      <v-sheet color="primary pa-2 ma-0" width="920px" height="58px">
        <v-btn width="180px" height="40px" color="secondary"
          @click="openInNewTab('https://store.steampowered.com/app/378370')" class="">
          <v-icon class="mr-1">mdi-steam</v-icon>Play Now
        </v-btn></v-sheet>
    </div>

    <div class="d-flex justify-center mb-2">
      <v-sheet class="" width="920px">

        <div class="d-flex justify-center mt-2">
          <iframe style="border-width: 0;" class="embed-responsive-item" src="https://www.youtube.com/embed/qO3lxF2bsr4" width=872px height=491px
            allowfullscreen>
          </iframe>
        </div>

        <div class="d-flex justify-center mb-4 pt-2">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Main_Steam.png?t=1703528081">
        </div>

        <p class="px-5">Nomad is a sandbox survival game. Hunt, craft, kill and survive! Find food, drink, weapons, ammo
          and medical
          supplies - or craft them! Build a base to protect yourself but also remember to protect the base from raiding
          players.</p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Explore.png?t=1703528081">
        </div>

        <p class="px-5">Set years after an apocalypse, the world is over grown, broken and abandoned. Explore the massive
          4km x 4km
          island to find gear and loot to aid in your adventures.
        </p>

        <p class="px-5">Remember, survival is key. Hunt for food and drink across the island, or simply kill others for
          it. Scavenge
          for medical items to heal broken bones and deep wounds.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Explore.gif?t=1703528081">
        </div>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_PVP.png?t=1703528081">
        </div>

        <p class="px-5">Find weapons and ammo and hunt down other players. Be that bloodthirsty bandito, or be a hero
          helping others -
          it's entirely up to you.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/pvp.gif?t=1703528081">
        </div>

        <div class="d-flex justify-center mb-4">
          <img
            src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Blood_Moons.png?t=1703528081">
        </div>


        <p class="px-5">Blood Moons will happen every 7 in-game days. Blood Moons are special as zombies have more health,
          spawn in
          greater numbers and can run faster. The Reaper will also spawn at Safe Zones which you can trade him Lost Souls
          for special in-game items. Gather Lost Souls by looting graves around the world.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Blood_Moon.gif?t=1703528081">
        </div>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Vehicles.png?t=1703528081">
        </div>

        <p class="px-5">Find, refuel and drive a range of vehicles to help traverse the island. Protect and store vehicles
          behind
          garage doors to keep them away from pesky raiders.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Vehicles.gif?t=1703528081">
        </div>

        <div class="d-flex justify-center mb-4">
          <img
            src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Base_Building.png?t=1703528081">
        </div>

        <p class="px-5">Create your own bases by chopping down trees for wood. First create your foundation and snap
          walls, windows,
          doorways and ceilings to it. Add a door and lock it. Place a workbench so that other players cannot build in the
          surrounding area. Make sure your workbench is hidden as other players can use it. Upgrade your wooden base to
          stone, metal and improved metal, by going out and mining with a pickaxe.</p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Base.gif?t=1703528081">
        </div>

        <div class="d-flex justify-center mb-4">
          <img
            src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Powered_Machines.png?t=1703528081">
        </div>

        <p class="px-5">Craft Generators that can power your base to add mining drills, electric lights, hydroponics
          farming stations,
          oil pumps, water pumps and many more. Bring your base to life with the power of electricity.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Powered_Machines.gif?t=1703528081">
        </div>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Farming.png?t=1703528081">
        </div>

        <p class="px-5">Find and collect packet of seeds around the world then use them to make your very own farm.
          Farming brings any
          benefits so make sure they are well protected.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Quests.png?t=1703528081">
        </div>

        <p class="px-5">Safe Zone Quests bring a new level of PvE content to Nomad. Complete over 30 quests that will make
          you travel
          all across the island to discover history and lore.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Sleepers.png?t=1703528081">
        </div>

        <p class="px-5">We all have to sleep sometime. In Nomad, disconnected players will sleep on the floor so make sure
          you are in a
          safe and protected area when logging off.
        </p>

        <div class="d-flex justify-center mb-4">
          <img
            src="https://store.steampowered.com/gfxproxy/betagfx/apps/378370/extras/Nomad_Host_Your_Own_Servers.png?t=1703528081">
        </div>

        <p class="px-5">Host your own server using the stand-a-lone server located at your Nomad Steam install directory.
          Set your own
          admins, make your own community.
        </p>

      </v-sheet>
    </div>

    <div class="d-flex justify-center mb-5">
      <v-sheet class="" width="920px">
        <p class="mx-3 mt-3">Need support for {{ name }}? Join our Discord <a href="https://discord.gg/UcKJdYb4dt" target="_blank">here</a></p>
      </v-sheet>
    </div>


  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Diminished Studios - Nomad',
    titleTemplate: '%s',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: "Nomad is a sandbox survival game. Hunt, craft, kill and survive!" },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:title', content: 'Diminished Studios - Nomad' },
      { property: 'og:image', content:'https://i.imgur.com/lVLowgo.png'}
    ]
  },
  data: () => ({
    name: 'Nomad', icon: "https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/apps/378370/c34113b7056542a07b43f8326a7f2918722ae8e1.jpg", capsule: "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/header.jpg?t=1703528081",
    images: ["https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_5d74b3746081fd5e4de235eab48b16e24abafc2b.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_3e8d3055db65352dd9cbf56abc8587faffdfef66.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_e81c041b8e6fb3ecdf0a0f0236c9114751c9b59c.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_f940b35d89c854867560b3ae7f3199f821adfa4b.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_7baf0dcabab37d7e9498f1518f006c0ce5ebaa33.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_672a476634a52c2e9d5cd9959d14771ef9c686be.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_7d96047bdec5dbb7c20a6af7ce813080c6bd814b.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_c51f265c93696e532fca556f3e059c38c7c1ad2f.600x338.jpg?t=1703528081",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/378370/ss_500ea47a3e0512158a64ae779b3ec862dc52e046.600x338.jpg?t=1703528081"]
  }),
  methods: {
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
  },
}
</script>

<style>
.v-image {
  .v-image__image {
    transition: all 0.4s;
  }

  &.zoom {
    .v-image__image {
      transform: scale(1.1);
    }
  }
}

.text {
  font-size: 13px;
  text-align: left;
}

.homepagecard {
  font-size: 16px;
  font-weight: bolder;
}

.homepagecarddesc {
  font-size: 14px;
}

.video {
  background-color: #181818;
  width: 100%;
}</style>
